import React from 'react';

interface PageHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Right-aligned slot for action buttons. */
  actions?: React.ReactNode;
  /** Optional eyebrow above the title (e.g. breadcrumb). */
  eyebrow?: React.ReactNode;
  /** Tighten spacing — used inside Card-based detail views. */
  dense?: boolean;
}

/** Consistent top-of-page hierarchy. */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  actions,
  eyebrow,
  dense,
}) => (
  <div className={dense ? 'mb-3' : 'mb-6'}>
    {eyebrow && (
      <div className="text-xs text-slate-600 mb-1.5">{eyebrow}</div>
    )}
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className={
          (dense ? 'text-xl' : 'text-2xl') +
          ' font-semibold text-slate-900 leading-tight truncate'
        }>
          {title}
        </h1>
        {description && (
          <p className="text-sm text-slate-600 mt-1">{description}</p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2 shrink-0">{actions}</div>
      )}
    </div>
  </div>
);

export default PageHeader;
